import { FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import { Option } from '@beeline/design-system-react/extracted-styles';

import {
  PersonAutocomplete,
  PersonAutocompleteProps,
} from '../PersonAutocomplete/PersonAutocomplete';

export interface FormPersonAutocompleteProps
  extends Omit<PersonAutocompleteProps, 'value' | 'onChange' | 'onInputClear'> {
  name: string;
  onChange?: (value: Option<string> | null) => void;
  onInputClear?: () => void;
  required?: boolean;
  validate?: (value: Option<string> | null) => string | Promise<string>;
}

export const FormPersonAutocomplete: FC<FormPersonAutocompleteProps> = ({
  name,
  onChange,
  onInputChange,
  required,
  validate: validateFromProps,
  ...rest
}) => {
  const validate = useCallback(
    async (value: Option<string> | null) => {
      if (!value && required) return 'Заполните поле';

      if (validateFromProps) return validateFromProps(value);
    },
    [required, validateFromProps],
  );
  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.modified || meta.submitFailed ? meta.error : undefined;

  const handleChange = useCallback(
    (value: Option<string> | null) => {
      input.onChange(value);
      onChange?.(value);
    },
    [input, onChange],
  );

  const handleInputChange = useCallback(
    (value: string) => {
      input.onChange(null);
      onInputChange?.(value);
    },
    [input, onInputChange],
  );

  return (
    <PersonAutocomplete
      {...rest}
      type='select'
      value={input.value}
      onChange={handleChange}
      onInputChange={handleInputChange}
      error={!!error}
      helperText={error}
    />
  );
};
